import { ReactElement } from 'react';

export type TabHeader = Pick<TabData, 'tabName' | 'icon' | 'num'>;

export type TabData = {
  id: number;
  tabName: string;
  icon?: ReactElement;
  num?: number;
  categories?: TabContentCategory[];
  numOfColumns?: number;
};

export enum TabContentCategory {
  ALL = 'all',
  ARTICLE = 'article',
  MEDICATION = 'medication',
  MEDIA = 'media',
}
